import { useLocation } from 'react-router-dom';

import Tabs from '@mui/material/Tabs';

import { LinkTab } from '../../../components/LinkTab';

export function AlgoTogetherTabs() {
  const location = useLocation();
  return (
    <Tabs
      indicatorColor="primary"
      textColor="inherit"
      variant="fullWidth"
      value={location.pathname}
    >
      <LinkTab
        label="Overview"
        to="/programs/algotogether"
        value="/programs/algotogether"
        key="/programs/algotogether"
      />
      <LinkTab
        label="Testimonials"
        to="/programs/algotogether/testimonials"
        value="/programs/algotogether/testimonials"
        key="/programs/algotogether/testimonials"
      />
      <LinkTab
        label="Success Stories"
        to="/programs/algotogether/stories"
        value="/programs/algotogether/stories"
        key="/programs/algotogether/stories"
      />
    </Tabs>
  );
}
